// src/plugins/socket.js

import Ws from '@adonisjs/websocket-client';

const ws = Ws(process.env.VUE_APP_WS_URL, {
  path: 'adonis-ws',
});

ws.connect();

ws.on('open', () => {
  console.log('WebSocket conectado');
});

ws.on('close', () => {
  console.log('WebSocket fechado');
});

ws.on('error', (error) => {
  console.log('Erro websocket', error);
});

export default ws;
